module.exports = "/_next/static/images/GOER-Incentives-Charles-a1a2442db6008643139a6602846de85c.svg";